import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';

export class TransportRegistrationDocumentScanController extends AbstractStepController {

    onContextChange(contextChange: ContextChange) {
        if (contextChange.key === TerminalContextConstants.registerTransportManually) {
            // this.onRegisterTransportManually();
        }
    }

    onRegisterToDashboardContext() {

    }

    public handleFlow(): FlowStepHandleResult {
        this.wizardComponent.startInactivityMonitoring();
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('document scan started');

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    private cancel() {
        const matDialog = WizardServiceLocator.injector.get(MatDialog);
        const dialogData: ConfirmDialogData = {
            titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
            messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
            confirm: () => {
                this.wizardComponent.stopInactivityMonitoring();
                this.wizardComponent.restartWizard();
            }
        };
        matDialog.open(ConfirmDialogComponent, {
            data: dialogData
        });
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();

        const previousControl = new StepControl();
        previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
        previousControl.type = StepControlType.BUTTON_STROKED;
        previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
        previousControl.controlAction = () => {
            this.wizardComponent.stopInactivityMonitoring();
            this.wizardComponent.previous();
        };
        controls.push(previousControl);

        var spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        const cancelControl = new StepControl();
        cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
        cancelControl.type = StepControlType.BUTTON_STROKED;
        cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
        cancelControl.controlAction = this.cancel.bind(this);
        controls.push(cancelControl);

        var spacer = new StepControl();
        spacer.type = StepControlType.SPACER;
        controls.push(spacer);

        const nextControl = new StepControl();
        nextControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.next';
        nextControl.type = StepControlType.BUTTON;
        nextControl.iconAfterCss = 'fa-thin fa-angle-right';
        nextControl.controlAction = () => {
            this.wizardComponent.stopInactivityMonitoring();
            this.wizardComponent.next();
        };
        controls.push(nextControl);

        return controls;
    }
}
